'use client';
import {
  Box,
  SimpleGrid,
  Stack,
  Tag,
  TagLabel,
  TagLeftIcon,
  Text,
} from '@chakra-ui/react';
import Image from 'next/image';

import LinkCustom from '@/app/_components/link/LinkCustom';
import { PriceFormat } from '@/app/_components/price-format/price-format';
import { ReactComponent as PromotionTag } from '@/app/_icons/promotion-tag_white.svg';
import { ReactComponent as StarTag } from '@/app/_icons/star.svg';
import { useFloatingCTA } from '@/hooks/floating-cta.hook';
import { assetsUri } from '@/services/api.service';
import { Special } from '@/types/specials/specials.types';
import { directusImageLoader } from '@/utils/loaders';

import ButtonCustom from '../button/ButtonCustom';

import Styles from './FleetPromotionsCard.module.scss';

const FleetPromotionsCard = ({ item }: { item: Special }) => {
  const { openLeadForm } = useFloatingCTA();

  const {
    title = '',
    sub_title = '',
    monthly_repayment = 0,
    payment_terms = 0,
    deposit = 0,
    residual = 0,
    interest_rate = 0,
    vehicle_type,
  } = item;

  return (
    <Box
      className={Styles.promotionsCard}
      display={'flex'}
      flexDirection={'column'}
    >
      <Image
        src={`${assetsUri}/${item.image}`}
        loader={directusImageLoader}
        className={Styles.promotionsCardImage}
        width={400}
        height={476}
        alt=""
      />
      <Box
        display={'flex'}
        flexDir={'row'}
        alignItems={'center'}
        justifyContent={'end'}
        className={Styles.promotionsCardHeader}
        gap={2}
        padding={6}
      >
        {vehicle_type === '5' ? (
          <Tag
            borderRadius={0}
            variant="solid"
            className={`${Styles.promotionTag} ${Styles.darkTag}`}
          >
            <TagLeftIcon as={StarTag} width={4} height={4} />

            <TagLabel>New</TagLabel>
          </Tag>
        ) : null}

        {payment_terms || deposit || residual || interest_rate ? (
          <Tag
            borderRadius={0}
            variant="solid"
            className={`${Styles.promotionTag} ${Styles.redTag}`}
          >
            <TagLeftIcon as={PromotionTag} width={4} height={4} />
            <TagLabel>Finance</TagLabel>
          </Tag>
        ) : null}
      </Box>
      <Box
        className={Styles.promotionsCardBody}
        marginTop={'auto'}
        paddingX={[2, 2, 6, 6]}
      ></Box>
      <Box
        className={Styles.promotionsCardFooter}
        paddingX={[6, 6, 6, 6]}
        paddingBottom={6}
      >
        <Stack
          display={'flex'}
          flexDirection={'row'}
          className={Styles.carModelDetail}
        >
          <Box>
            <Box className={Styles.carModelName}>{title}</Box>
            <Box className={Styles.carInfo} maxW={'180'} width={'100%'} mt={4}>
              <Text className={Styles.description}>{sub_title}</Text>
            </Box>
          </Box>
          <Box className={Styles.carPriceInfo} marginLeft={'auto'}>
            <Text className={Styles.carPriceDesc}>Zero deposit from</Text>
            <Text className={Styles.carPrice}>
              <PriceFormat
                thousandSeparator=","
                prefix="R"
                value={monthly_repayment}
              />{' '}
              p/m
            </Text>
          </Box>
        </Stack>
        <SimpleGrid
          columns={[2, 2, 2, 2]}
          alignItems={'start'}
          spacing={[3]}
          mt={6}
          className={Styles.footerCTA}
        >
          <LinkCustom
            className="btnOutlineWhite"
            moduleClass={Styles.btnCTA}
            href={`/promotions/${item.id}`}
          >
            Explore
          </LinkCustom>
          <ButtonCustom
            className="btnOutlineWhite"
            moduleClass={Styles.btnCTA}
            onClick={() => openLeadForm('fleet', 'Fleet')}
          >
            Get In Touch
          </ButtonCustom>
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default FleetPromotionsCard;
